/*
|----------------------------------------------------------------------------------------------
| NAVIGATION HANDLER: Dynamically attach onclick events to single parent profiles in nav
|----------------------------------------------------------------------------------------------
*/

__gh__webApp.navHandler = {
	"init":function(){
	    $('#drawer-nav-sections > li').each(function() {
		    var n = $(this).children('.subnav').length;
		    if($(n).length == 0){
				$(this).children('a').addClass('noSubLinks'); // get links that have no sub nav & add class to link
		    }
		});

		$('.noSubLinks').click(function() {
	      window.location.href=$(this).attr('href');
		});

		$('#button-nav-toggle, #drawer-fade-screen, #drawer-close').on('click touchstart',function(e) {
			$('#drawer, #drawer-fade-screen').toggleClass('is-visible');
			e.preventDefault();
		});
	}

};
